<div ngModelGroup="site" class="col-sm-12 card-body" >
	<!-- Basic Site Info -->
	<div class="card mb-3 ng-star-inserted">
		<legend class="card-header">{{'g.info' | translate}}</legend>
		<div class="row mt-2 ml-2 align-items-center">
			<div class="col-md-3">
				<strong>{{'site_edit.name' | translate}}</strong>
				<span class="ml-1">*</span>
			</div>
			<div class="col-md-8">
				<input #siteNameComponent [disabled]="site.is_special" required pattern="[^\s].*" type="text" class="form-control" [(ngModel)]="site.name" placeholder="Name" name="name" autofocus/>
			</div>
		</div>
		<div class="row mt-2 ml-2 align-items-center" *ngIf="!hideAddressFields">
			<div class="col-md-3">
				<strong>{{'site_edit.country' | translate}}</strong>
			</div>
			<div class="col-md-8">
				<input required type="text" class="form-control" [readonly]="true" [(ngModel)]="site.country_id" placeholder="Country" name="country_id" />
			</div>
		</div>
		<div class="row mt-2 ml-2 align-items-center" *ngIf="!hideAddressFields">
			<div class="col-md-3">
				<strong>{{'site_edit.state' | translate}}</strong>
			</div>
			<div class="col-md-8">
				<input required type="text" class="form-control" [readonly]="true" [(ngModel)]="site.state_id" placeholder="State" name="state_id" />
			</div>
		</div>
		<div class="row mt-2 ml-2 align-items-center" *ngIf="!hideAddressFields">
			<div class="col-md-3">
				<strong>{{'site_edit.city' | translate}}</strong>
			</div>
			<div class="col-md-8">
				<input type="text" class="form-control" [readonly]="true" [(ngModel)]="site.city" placeholder="City" name="city" />
			</div>
		</div>
		<div class="row mt-2 ml-2 align-items-center" *ngIf="!hideAddressFields">
			<div class="col-md-3">
				<strong>{{'site_edit.address' | translate}}</strong>
			</div>
			<div class="col-md-8 d-flex">
				<input required type="text" name="address" class="form-control" [readonly]="!addressEditable" [(ngModel)]="site.address" placeholder="Address" />

				<div class="input-group-append" *ngIf="!addressEditable">
					<button
						type="button"
						class="btn btn-outline-secondary"
						(click)="enableAddressEdit()"
						title="Edit Address">
						<i class="fa fa-pencil"></i>
					</button>
				</div>
			</div>
		</div>
		<div class="row mt-2 ml-2 align-items-center">
			<div class="col-md-3">
				<strong>{{'site_edit.address_line2' | translate}}</strong>
			</div>
			<div class="col-md-8">
				<input type="text" name="address_line2" class="form-control" [(ngModel)]="site.address_line2" placeholder="Apartment, building, floor" />
			</div>
		</div>
		<div class="row mt-2 ml-2 align-items-center" *ngIf="!hideInternalSections && usersService.hasAccessPermission(null, 'basic_setup')"> 
			<div class="col-md-3">
				<strong>{{'site_edit.fseid' | translate}}</strong>
			</div>
			<div class="col-md-8">
				<input type="text" name="fse_id" class="form-control" [(ngModel)]="site.fse_id"/>
			</div>
		</div>
		<div class="row mt-2 ml-2 align-items-center" *ngIf="!hideAddressFields">
			<div class="col-md-3">
				<strong>{{'site_edit.latitude' | translate}}</strong>
			</div>
			<div class="col-md-8">
				<input required type="text" name="latitude" class="form-control" [readonly]="true" [(ngModel)]="site.latitude" placeholder="Latitude" />
			</div>
		</div>
		<div class="row mt-2 ml-2 align-items-center" *ngIf="!hideAddressFields">
			<div class="col-md-3">
				<strong>{{'site_edit.longitude' | translate}}</strong>
			</div>
			<div class="col-md-8">
				<input required type="text" name="longitude" class="form-control" [readonly]="true" [(ngModel)]="site.longitude" placeholder="Longitude" />
			</div>
		</div>
		<div class="row mt-2 ml-2 align-items-center">
			<div class="col-md-3">
				<strong>{{'site_edit.time_zone' | translate}}</strong>
				<span class="ml-1">*</span>
			</div>
			<div class="col-md-8">
				<ng-select [items]="timeZonesMenu" bindLabel="display_name" bindValue="id" placeholder="Select Time Zone" name="zone_id" [(ngModel)]="site.zone_id" [clearable]="false" required>
				</ng-select>
			</div>
		</div>
		<div class="row mt-2 ml-2 align-items-center">
			<div class="col-md-3">
				<strong>{{'site_edit.installation_date' | translate}}</strong>
			</div>
			<div class="col-md-8 mb-2">
				<div class="input-group">
					<input class="form-control" placeholder="mm/dd/yyyy" name="installation_date" [minDate]="minInstallationDate" [(ngModel)]="site.installation_date" bsDatepicker #d="bsDatepicker" [bsConfig]="{ containerClass: 'theme-dark-blue' }" required>
					<span class="input-group-btn">
						<button class="btn btn-default btn-date" (click)="d.toggle()" type="button"><i class="fa fa-calendar"></i></button>
					</span>
				</div>
			</div>
		</div>
	</div>

	<!-- Enterprise Info-->
	<div class="card mb-3 ng-star-inserted" *ngIf="!hideInternalSections && !hideEnterprise && enterpriseList.length > 0">
		<legend class="card-header">{{'site.site_enterprise' | translate}}</legend>
		<div class="row mt-2 ml-2 align-items-center" >
			<div class="col-md-3">
				<strong>{{'site_edit.enterprise_group' | translate}}</strong>
			</div>
			<div class="col-md-8">
				<ng-select [multiple]="true" id="enterprise_ids" [items]="enterpriseList" bindLabel="name" bindValue="id" placeholder="{{'site_edit.select_enterprise_group' | translate}}" name="enterprise_ids" [(ngModel)]="site.enterprise_ids" [clearable]="false" required>
				</ng-select>
			</div>
		</div>

		<div class="row mt-2 ml-2 align-items-center">
			<div class="col-md-3">
				<strong>{{'customer.customer_enterprises' |translate}}</strong>
			</div>
			<div class="col-md-8 mb-2">
				<ng-select
					[items]="customerEnterprises"
					bindLabel="name"
					bindValue="id"
					id="customer_enterprises"
					name="customer_enterprises"
					[clearable]="false"
					placeholder="{{'customer.customer_enterprises' | translate}}"
					[(ngModel)]="site.customer_enterprises"
					multiple="true"
					[disabled]="true"
				></ng-select>
			</div>
		</div>
	</div>

	<!-- Site settings-->
	<div class="card mb-3 ng-star-inserted" *ngIf="!hideInternalSections && !hideSettings && showSiteSettingsInfo()">
		<legend class="card-header">{{'site.site_settings' | translate}}</legend>
		<div class="row mt-2 ml-2 align-items-center" *ngIf="usersService.hasAccessFunction('official_reporting') || usersService.hasAccessPermission(null, 'noc')">
			<div class="col-md-3">
				<strong>{{'site_edit.is_smart_rebates_site' | translate}}</strong>
			</div>
			<div class="col-md-9">
				<div class="form-check form-check-inline slide-toggle-div">
					<mat-slide-toggle
						[disabled]=" !usersService.hasAccessFunction('official_reporting') && !usersService.hasAccessPermission(null, 'noc', 'write')"
						[(ngModel)]="site.is_smart_rebates" name="is_smart_rebates"
					>
					</mat-slide-toggle>
				</div>
			</div>
		</div>
		<div class="row mt-2 ml-2 align-items-center" *ngIf="!miniForm && usersService.hasAccessPermission(null, 'noc')">
			<div class="col-md-3">
				<strong>{{'site_edit.password_mode' | translate}}</strong>
			</div>
			<div class="col-md-9">
				<div class="radio-group">
					<div class="form-check" *ngFor="let mode of passwordModes">
						<input
							type="radio"
							class="form-check-input"
							[id]="'password_mode_' + mode.value"
							[value]="mode.value"
							[(ngModel)]="site.password_mode"
							name="password_mode"
							[disabled]="!canEditPasswordMode()"
						/>
						<label class="form-check-label" [for]="'password_mode_' + mode.value">
							{{ mode.label | translate }}
						</label>
					</div>
				</div>
			</div>
		</div>
		<div class="row mt-2 ml-2 align-items-center" *ngIf="enterpriseList.length > 0">
			<div class="col-md-3">
				<strong>{{'site_edit.is_verified' | translate}}</strong>
			</div>
			<div class="col-md-9">
				<div class="form-check form-check-inline slide-toggle-div">
					<mat-slide-toggle [(ngModel)]="site.is_verified" name="is_verified"></mat-slide-toggle>
				</div>
			</div>
		</div>
		<div class="row mt-2 ml-2 align-items-center" *ngIf="enterpriseList.length > 0">
			<div class="col-md-3">
				<strong>{{'site_edit.is_test_site' | translate}}</strong>
			</div>
			<div class="col-md-9">
				<div class="form-check form-check-inline slide-toggle-div">
					<mat-slide-toggle [(ngModel)]="site.test_site" name="test_site"></mat-slide-toggle>
				</div>
			</div>
		</div>
		<div class="row mt-2 ml-2 align-items-center" *ngIf="enterpriseList.length > 0">
			<div class="col-md-3">
				<strong>{{'site_edit.is_special_site' | translate}}</strong>
			</div>
			<div class="col-md-9 mb-2">
				<div class="form-check form-check-inline slide-toggle-div">
					<mat-slide-toggle [disabled]="restrictSpecialSite" [(ngModel)]="site.is_special" name="is_special"></mat-slide-toggle>
				</div>
			</div>
		</div>
	</div>

	<!-- IoTemeter Site Settings-->
	<div class="card mb-3 ng-star-inserted" *ngIf="showIotMeterOptions">
		<legend class="card-header">{{'site.im_site_settings' | translate}}</legend>
		<div>
			<div class="row mt-2 ml-2 align-items-center">
				<div class="col-md-3">
					<strong>{{'site.iotemeter_site.site_contain_iotemeter_devices' | translate}}</strong>
				</div>
				<div class="col-md-8">
					<div class="form-check form-check-inline slide-toggle-div">
						<mat-slide-toggle [(ngModel)]="site.is_contain_iotemeter_devices" name="is_contain_iotemeter_devices" (change)="isContainIotEmeterDevices($event.checked)"></mat-slide-toggle>
					</div>
				</div>
			</div>

			<div class="row mt-2 ml-2 align-items-center" *ngIf="site.is_contain_iotemeter_devices && allMeterCustomers.length">
				<div class="col-md-3">
					<strong>{{'site.iotemeter_site.meter_customer_name' | translate}}</strong>
					<span class="ml-1">*</span>
				</div>
				<div class="col-md-8">
					<ng-select 
						[items]="allMeterCustomers" 
						bindLabel="name" 
						bindValue="id" 
						placeholder="{{'site.iotemeter_site.meter_customer_name' | translate}}" 
						name="iotemeter_customer_id"
						[(ngModel)]="site.iotemeter_customer_id" 
						[clearable]="false"
						(change)="onCustomerSelect($event.id)"
						required
					>
					</ng-select>
				</div>
			</div>
	
			<div class="row mt-2 ml-2 mb-2 align-items-center" *ngIf="site.is_contain_iotemeter_devices && selectedMeterCustomerSites.length">
				<div class="col-md-3">
					<strong>{{'site.iotemeter_site.meter_site_name' | translate}}</strong>
					<span class="ml-1">*</span>
				</div>
				<div class="col-md-8">
					<ng-select 
						[items]="selectedMeterCustomerSites" 
						bindLabel="name"
						bindValue="id" 
						placeholder="{{'site.iotemeter_site.meter_site_name' | translate}}"
						name="iotemeter_site_id" 
						[(ngModel)]="site.iotemeter_site_id" 
						[clearable]="false" 
						[multiple]="false"
						required
					>
					</ng-select>
				</div>
			</div>
		</div>
	</div>

	<!-- Multi Tariff profile -->
	<div class="card mb-3" *ngIf="!hideInternalSections && canEditMultiTariffProfile && multiTariffProfiles.length">
		<legend class="card-header">{{'multi_tariff.menu_label' | translate}}</legend>
		<div class="row mt-2 ml-2 mb-2 align-items-center">
			<div class="col-md-3">
				<strong>{{'multi_tariff.profile.list' | translate}}</strong>
			</div>
			<div class="col-md-8">
				<ng-select
					[items]="multiTariffProfiles"
					bindLabel="name"
					bindValue="id"
					placeholder="{{'multi_tariff.profile.list' | translate}}"
					name="profile_id"
					[(ngModel)]="site.profile_id"
					[clearable]="false"
				></ng-select>
			</div>
		</div>
	</div>

	<!-- Recept Group -->
	<div class="card mb-3 ng-star-inserted" *ngIf="!hideInternalSections && !miniForm && usersService.hasAccessPermission(null, 'noc','write') && site.is_smart_rebates && recipientGroups.length">
		<legend class="card-header">{{'site.site_recipient_groups' | translate}}</legend>
		<div class="row mt-2 ml-2 align-items-center">
			<div class="col-md-3">
				<strong>{{'site_groups.recipient_group' | translate}}</strong>
			</div>
			<div class="col-md-8">
				<ng-select
					[multiple]="true"
					id="recipient_group"
					[items]="recipientGroups"
					bindLabel="name"
					bindValue="id"
					placeholder="{{'site_groups.recipient_group' | translate}}"
					name="recipient_group"
					[(ngModel)]="site.recipient_groups"
					[clearable]="false"
					(change)="updateRecipientGroupUsers()"
				>
				</ng-select>
			</div>
		</div>

		<div class="row mt-2 ml-2 mb-2 align-items-center">
			<div class="col-md-3">
				<strong>{{'site_groups.recipient_group_users' |translate}}</strong>
			</div>
			<div class="col-md-8">
				<ng-select
					[items]="siteRecipientGroupsUsersList"
					bindLabel="name"
					bindValue="id"
					id="site_recipient_groups_users"
					name="site_recipient_groups_users"
					placeholder="{{'site_groups.recipient_group_users' | translate}}"
					[(ngModel)]="siteRecipientGroupsUsersIds"
					[multiple]="true"
					[disabled]="true"
				></ng-select>
			</div>
		</div>
	</div>

	<!-- Site Contact Info -->
	<div class="card mb-3 ng-star-inserted" *ngIf="!hideInternalSections && !miniForm">
		<legend class="card-header">{{'site_edit.site_contact_info' | translate}}</legend>

		<div class="row mt-2 ml-2 align-items-center">
			<div class="col-md-3"><strong>{{'site_edit.name' | translate}}</strong></div>
			<div class="col-md-8">
				<input class="form-control" 
					name="contact_name"
					type="text"
					[(ngModel)]="site.contact_name" 
					placeholder="Person Name" 
				/>
			</div>
		</div>
		<div class="row mt-2 ml-2 align-items-center">
			<div class="col-md-3"><strong>{{'site_edit.phone' | translate}}</strong></div>
			<div class="col-md-8">
				<input class="form-control" 
					name="phone_num"
					type="text" 
					[(ngModel)]="site.phone_num" 
					placeholder="Phone No."
				/>
			</div>
		</div>
		<div class="row mt-2 ml-2 mb-2 align-items-center">
			<div class="col-md-3"><strong>{{'site_edit.email' | translate}}</strong></div>
			<div class="col-md-8">
				<input class="form-control" 
					name="email" [(ngModel)]="site.email"
					type="email"
					placeholder="Email" 
				/>
			</div>
		</div>
	</div>

	<!-- Electrician Contact Info -->
	<div class="card mb-3 ng-star-inserted" *ngIf="!hideInternalSections && !miniForm">
		<legend class="card-header">{{'site.electrician_contact_info' | translate}}</legend>

		<div class="row mt-2 ml-2 align-items-center">
			<div class="col-md-3"><strong>{{'site_edit.name' | translate}}</strong></div>
			<div class="col-md-8">
				<input class="form-control" 
					name="electrician_contact_name"
					type="text"
					[(ngModel)]="site.electrician_contact_name" placeholder="Name" />
			</div>
		</div>
		<div class="row mt-2 ml-2 align-items-center">
			<div class="col-md-3"><strong>{{'site_edit.phone' | translate}}</strong></div>
			<div class="col-md-8">
				<input class="form-control" 
					name="electrician_phone_num"
					type="text"
					[(ngModel)]="site.electrician_phone_num" placeholder="Phone No." 
				/>
			</div>
		</div>
		<div class="row mt-2 ml-2 mb-2 align-items-center">
			<div class="col-md-3"><strong>{{'site_edit.email' | translate}}</strong></div>
			<div class="col-md-8">
				<input class="form-control" 
					name="electrician_email"
					type="email" 
					[(ngModel)]="site.electrician_email" placeholder="Email"
				/>
			</div>
		</div>
	</div>

	<!-- Sales Person Info -->
	<div class="card mb-3 ng-star-inserted" *ngIf="!hideInternalSections && !miniForm">
		<legend class="card-header">{{'site.sales_person_info' | translate}}</legend>

		<div class="row mt-2 ml-2 align-items-center">
			<div class="col-md-3"><strong>{{'site_edit.name' | translate}}</strong></div>
			<div class="col-md-8">
				<input class="form-control" 
					name="sales_person_name"
					type="text"
					[(ngModel)]="site.sales_person_name" placeholder="Name" 
				/>
			</div>
		</div>
		<div class="row mt-2 ml-2 align-items-center">
			<div class="col-md-3"><strong>{{'site_edit.phone' | translate}}</strong></div>
			<div class="col-md-8"><input type="text" class="form-control" name="sales_person_phone_num"
					[(ngModel)]="site.sales_person_phone_num" placeholder="Phone No." /></div>
		</div>
		<div class="row mt-2 ml-2 mb-2 align-items-center">
			<div class="col-md-3"><strong>{{'site_edit.email' | translate}}</strong></div>
			<div class="col-md-8">
				<input class="form-control" 
					name="sales_person_email"
					type="text"
					[(ngModel)]="site.sales_person_email" placeholder="Email" 
				/>
			</div>
		</div>
	</div>
</div>
